@if ($renderImage()) {
<img
	[ngClass]="$imgClasses()"
	[src]="$src()"
	(error)="onError()"
	style="width: 100%; height: 100%; object-fit: cover"
/>
} @else {
<ng-content></ng-content>
}
